import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import { useCompanyUsersStore } from "@/pinia/subcompanies/companyUsers";
import { CompanyEmployeeModel } from "@/services/types/employee";
import { StatusType } from "@/services/types/base";
import { i18n } from "@/i18n";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import ConfirmationComponent from "@/components/modal/ConfirmationComponent.vue";
import EditUserFormModal from "@/components/company/forms/EditUserFormModal.vue";
import { getUserFio } from "@/services/utils";
import BadgesList from "@/components/ui/BadgesList.vue";
import { getRolesLabels } from "@/services/roles/utils";

//#region Config

export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyUsersListGrid',
  setup(__props) {

const fields = [
  {
    key: "lastname",
    sortable: true,
    label: "ФИО",
    tdClass: "name-td",
    thClass: "name-th",
  },
  {
    key: "status",
    sortable: true,
    label: "Статус",
    tdClass: "status-td",
    thClass: "status-th",
  },
  {
    key: "email",
    sortable: true,
    label: "Email",
    tdClass: "email-td",
    thClass: "email-th",
  },
  {
    key: "phone",
    sortable: true,
    label: "Phone",
    tdClass: "phone-td",
    thClass: "phone-th",
  },
  {
    key: "roles",
    label: "Роли",
    sortable: false,
    tdClass: "action-td",
    thClass: "action-th",
  },
  {
    key: "action",
    label: "",
    sortable: false,
    tdClass: "action-td",
    thClass: "action-th",
  },
];
const actionsIcon = faEllipsisV;
//#endregion

const companyUsersStore = useCompanyUsersStore();
const users = computed(() => {
  return companyUsersStore.getFilteredUsers;
});

// const editUserId = ref<number>(null);
const editUserData = ref<CompanyEmployeeModel>(null);
const editUserName = computed<string>(() => {
  return editUserData.value ? getUserFio(editUserData.value) : null;
});

//#region Actions
const editUserModalShow = ref(false);

function handleEditUserClick(user: CompanyEmployeeModel) {
  editUserData.value = user;
  editUserModalShow.value = true;
}

//#endregion

//#region Delete User
const deleteUserConfirmationShow = ref(false);

function handleDeleteUserClick(user: CompanyEmployeeModel) {
  editUserData.value = user;
  deleteUserConfirmationShow.value = true;
}

async function deleteUser() {
  await companyUsersStore.deleteUser(editUserData.value.id);
  deleteUserConfiramationClose();
  await companyUsersStore.fetchUsers(companyUsersStore.company?.id);
}

function deleteUserConfiramationClose() {
  deleteUserConfirmationShow.value = false;
  editUserData.value = null;
}

//#endregion

//#region Helpers

function getStatus(status: StatusType) {
  return status == "ACTIVE"
    ? i18n.t("criterionsDetails.title.active")
    : i18n.t("criterionsDetails.title.deactive");
}

function getChangeStatusItemTitle(status: StatusType) {
  return status == "ACTIVE"
    ? i18n.t("criterionsDetails.item.deactivate")
    : i18n.t("criterionsDetails.item.activate");
}

//#endregion

return { __sfc: true,fields, actionsIcon, companyUsersStore, users, editUserData, editUserName, editUserModalShow, handleEditUserClick, deleteUserConfirmationShow, handleDeleteUserClick, deleteUser, deleteUserConfiramationClose, getStatus, getChangeStatusItemTitle, ConfirmationComponent, EditUserFormModal, getUserFio, BadgesList, getRolesLabels }
}

})